import { render, staticRenderFns } from "./PersonName.vue?vue&type=template&id=5c2a6dca&scoped=true"
import script from "./PersonName.vue?vue&type=script&lang=js"
export * from "./PersonName.vue?vue&type=script&lang=js"
import style0 from "./PersonName.vue?vue&type=style&index=0&id=5c2a6dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a6dca",
  null
  
)

export default component.exports